import LandingPage from "../UiControllers/LandingPage/landingPage.js";

new LandingPage({})